import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2795400400/src/src/app/apps/components/ContentApps.tsx");
